var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.63576 0.634464C8.93667 0.461943 9.30362 0.451724 9.61362 0.607232L17.41 4.51831L24.1844 0.634464C24.5052 0.450531 24.8994 0.451852 25.219 0.63793C25.5386 0.824009 25.7353 1.16671 25.7353 1.53744V18.1774C25.7353 18.5506 25.536 18.8952 25.213 19.0804L17.957 23.2404C17.656 23.4129 17.2891 23.4231 16.9791 23.2676L9.18266 19.3565L2.40829 23.2404C2.08746 23.4243 1.69331 23.423 1.37371 23.2369C1.05412 23.0508 0.857422 22.7081 0.857422 22.3374V5.69743C0.857422 5.32422 1.05674 4.97962 1.37971 4.79446L8.63576 0.634464ZM9.18266 2.71655L2.93058 6.30096V20.5453L8.63576 17.2744C8.93667 17.1019 9.30362 17.0917 9.61362 17.2472L17.41 21.1583L23.6621 17.5739V3.32954L17.957 6.6004C17.656 6.77292 17.2891 6.78314 16.9791 6.62763L9.18266 2.71655Z",
    fill: "#F2F2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.14998 0.497437C9.72247 0.497437 10.1866 0.96306 10.1866 1.53744V18.1774C10.1866 18.7518 9.72247 19.2174 9.14998 19.2174C8.57749 19.2174 8.1134 18.7518 8.1134 18.1774V1.53744C8.1134 0.96306 8.57749 0.497437 9.14998 0.497437Z",
    fill: "#F2F2F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4427 4.65747C18.0152 4.65747 18.4793 5.12309 18.4793 5.69747V22.3374C18.4793 22.9118 18.0152 23.3774 17.4427 23.3774C16.8702 23.3774 16.4061 22.9118 16.4061 22.3374V5.69747C16.4061 5.12309 16.8702 4.65747 17.4427 4.65747Z",
    fill: "#F2F2F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIcon);
export default __webpack_public_path__ + "static/media/MapIcon.3f84033b2e080268a9d2225a1b5299c9.svg";
export { ForwardRef as ReactComponent };